import styled from "styled-components"
import Breakpoints from "../../components/shared/breakpoints"
import {handleArrayVariants} from './merge-variants'

const withVariants = WrappedComponent => {

  return styled(WrappedComponent)`
  ${props => Array.isArray(props.variants) ? props.variants[0] : props.variants?.sm}
  
  @media(min-width: ${Breakpoints.md}) {
    ${props => Array.isArray(props.variants) ? props.variants[1] : props.variants?.md}
  }
  
  @media(min-width: ${Breakpoints.lg}) {
    ${props => Array.isArray(props.variants) ? props.variants[2] : props.variants?.lg}
  }
  `
}

export default withVariants
